module.exports = __webpack_public_path__ + "static/media/intro-background-full.6ba6829f.png";